import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { PRODUCT, PRODUCT_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetProduct,
    asyncGetProductHistorical,
    asyncUpdateProduct,
    asyncCreateProduct,
} from '../../../../../services/product.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import {
    Product,
    ProductHistorical,
} from '../../../../../shared/types/systemConfiguration/products';

export const useProductForm = () => {
    const navigate = useNavigate();
    const { idProduct } = useParams();
    const [product, setProduct] = useState<Product>();
    const [loading, setLoading] = useState(false);
    const [formikProductData, setFormikProductData] =
        useState<FormikProps<Product>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [productHistorical, setProductHistorical] =
        useState<ProductHistorical[]>();

    const isValidForm = formikProductData?.isValid;

    const handleCleanAndBack = () => {
        formikProductData?.resetForm();
        navigate(PRODUCT);
    };

    const handleSubmit = async () => {
        await formikProductData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Product = formikProductData?.values;

        let res: any | undefined = undefined;

        try {
            if (product && product.id)
                res = await asyncUpdateProduct(product.id, data);
            else res = await asyncCreateProduct(data);
        } catch (error) {}
        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! el producto se ${
                    product && product.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${PRODUCT_DETAIL}/${res.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    product && product.id ? 'actualizar' : 'crear'
                } el producto. Por favor, asegúrate de ${
                    product && product.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idProduct)) {
            setLoading(true);
            asyncGetProduct(idProduct)
                .then((product: any) => {
                    if (!product) navigate(PRODUCT);
                    setProduct(product);
                })
                .finally(() => setLoading(false));
        }
    }, [idProduct]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetProductHistorical(idProduct)
                .then((resp) => {
                    if (resp) setProductHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        product,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikProductData,
        productHistorical,
        showHistorical,
        setShowHistorical,
    };
};
